import getLocal from '@/app/utils/getLocal';
import ProductEu from './ProductEu';
import ProductAu from './ProductAu';
import ProductNa from './ProductNa';

export default function Teaser() {
    const { locale } = getLocal();

    if (['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale)) {
        return <ProductEu />;
    }

    if (['au'].includes(locale)) {
        return <ProductAu />;
    }

    return (
        <>
            <ProductNa />
        </>
    );
}
